import { useCallback } from 'react';
import { NodeWithoutDescription } from '../../../api/table-of-content';
import NodeBranch from './NodeBranch';

import List from '@pelckmans/elementis/components/list';

type Props = {
  nodes: NodeWithoutDescription[];
  onSelect: (node: NodeWithoutDescription) => void;
  selectedNodeId: string | null;
};

function NodeTree({ nodes, onSelect, selectedNodeId }: Props) {
  const renderBranches = useCallback(
    (nodes: NodeWithoutDescription[], level: number = 0, hasCollapsibleParent: boolean = false): JSX.Element[] =>
      nodes.map(node => (
        <NodeBranch
          key={node.id}
          node={node}
          level={level}
          renderBranches={renderBranches}
          onSelect={onSelect}
          selectedNodeId={selectedNodeId}
          hasCollapsibleParent={hasCollapsibleParent}
        />
      )),
    [onSelect, selectedNodeId],
  );

  return <List>{renderBranches(nodes)}</List>;
}

export default NodeTree;
